import UcDemo from './UcDemo.jsx';

export default () => {
    return {
        path: '/UcDemo',
        element: <UcDemo />,
    }
}